import { SegmentedControl, Text } from '@mantine/core';
import { IconArrowDown, IconArrowLeft, IconArrowRight, IconArrowUp } from '@tabler/icons-react';
import React from 'react';
import type { SwipeDirection } from '~/common/recorder/recorder-operation';
import { isSwipeDirection } from '~/common/recorder/recorder-operation';
import { cn } from '~/common/string/classname';

export const SwipeDirectionInput = React.forwardRef<
  HTMLDivElement,
  {
    onDirectionSelect?: (direction: SwipeDirection) => void;
    label?: string;
    className?: string;
    value?: SwipeDirection;
    onSubmit?: () => void;
  }
>(({ onDirectionSelect, label, className, value, onSubmit }, ref) => {
  const handleDirectionChange = (selectedDirection: string) => {
    if (isSwipeDirection(selectedDirection)) {
      onDirectionSelect?.(selectedDirection);
    }
    onSubmit?.();
  };

  return (
    <div
      className={cn('flex flex-col gap-2', className)}
      ref={ref}
    >
      {!!label && <Text size="sm">{label}</Text>}
      <SegmentedControl
        value={value}
        onChange={handleDirectionChange}
        data={[
          {
            value: 'left' satisfies SwipeDirection,
            label: (
              <div className="flex items-center gap-1">
                <IconArrowLeft size={16} />
                <span>Left</span>
              </div>
            ),
          },
          {
            value: 'right' satisfies SwipeDirection,
            label: (
              <div className="flex items-center gap-1">
                <IconArrowRight size={16} />
                <span>Right</span>
              </div>
            ),
          },
          {
            value: 'up' satisfies SwipeDirection,
            label: (
              <div className="flex items-center gap-1">
                <IconArrowUp size={16} />
                <span>Up</span>
              </div>
            ),
          },
          {
            value: 'down' satisfies SwipeDirection,
            label: (
              <div className="flex items-center gap-1">
                <IconArrowDown size={16} />
                <span>Down</span>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
});

SwipeDirectionInput.displayName = 'SwipeDirectionInput';
